import { useEffect, useState } from "react";
import { Video } from "lucide-react";
import api from "@/lib/api";

// Highlighted, admin-editable open-box video requirement for returns/refunds.
// `where` = "checkout" | "orders" — respects the admin position toggles.
export function ReturnVideoNotice({ where, className = "" }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get("/marketplace/public/return-policy").then((r) => setP(r.data.policy)).catch(() => {});
  }, []);
  if (!p || !p.enabled) return null;
  const on = where === "checkout" ? p.show_checkout : where === "orders" ? p.show_orders : true;
  if (!on) return null;
  return (
    <div data-testid={`return-video-notice-${where}`} className={`rounded-xl border border-amber-300 border-l-4 border-l-amber-500 bg-amber-50 p-4 ${className}`}>
      <p className="flex items-center gap-2 text-sm font-bold text-amber-800"><Video className="h-4 w-4 shrink-0" /> {p.title || "Return & Refund verification"}</p>
      <p className="mt-1 text-sm leading-relaxed text-amber-900/90">{p.text}</p>
    </div>
  );
}
